export enum EProfileUrl {
  PROFILE = 'profile',
  SEARCH = 'search',
}
